<template>
  <div class="text-xs-center">
    <v-dialog :value="value" @input="$emit('input')" width="90%">
      <v-card>
        <!-- <v-card-title class="headline grey lighten-2 py-0" primary-title>
          Altera Atividade
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <v-btn flat fab small icon @click="$emit('input')" slot="activator">
              <v-icon>close</v-icon>
            </v-btn>
            <span>Cancelar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn
              color="primary"
              fab
              dark
              small
              @click="adiciona"
              :loading="loading"
              slot="activator"
            >
              <v-icon>done</v-icon>
            </v-btn>
            <span>Salvar</span>
          </v-tooltip>
        </v-card-title> -->

        <v-card-text class="pa-0">
          <!-- <Cadastro /> -->
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import Cadastro from '@/components/atividade/Cadastro'

export default {
  name: 'ModalAtividade',
  props: ["value", "atividade", "loading"],
  components: {
    Cadastro,
  },
  methods: {
    ...mapMutations(["showNotification"]),
    adiciona() {
      console.log('Altera atividade');
    }
  },
};
</script>

<style>
</style>
